import React from 'react'
import * as UI from 'ui'
import Logo from 'widgets/branding/Logo'
import Widget from 'widgets/Widget'
import ImpersonationBar from 'widgets/auth/ImpersonationBar'

export default function ForcedNotificationWrapper ({ children }) {
  return (
    <>
      <ImpersonationBar />
      <div className='min-h-screen bg-background flex flex-col justify-center py-12 sm:px-6 lg:px-8'>
        <div className='sm:mx-auto sm:w-full sm:max-w-md flex flex-col items-center'>
          <div className='w-24'>
            <Logo />
          </div>
        </div>

        <div className='mt-8 mx-2 sm:mx-auto sm:w-full sm:max-w-3xl'>
          <Widget>
            <UI.Card>
              {children}
            </UI.Card>
          </Widget>
        </div>

      </div>
    </>
  )
}
